<h2 mat-dialog-title>Seleccione los parámetros para generar el PDF</h2>
<mat-dialog-content>
  <mat-label style="margin-bottom: 8px; display: block">Seleccione una o más fechas</mat-label>
  <ng-container *ngFor="let fecha of fechas; let i = index">
    <mat-checkbox color="primary" [checked]="fecha.checked" (change)="fecha.checked = $event.checked">{{fecha.fecha}}
    </mat-checkbox><br>
  </ng-container>
  <div style="margin-top: 16px">
    <mat-label style="margin-bottom: 8px; display: block">Seleccione al menos una opción</mat-label>
    <mat-checkbox color="primary" [checked]="isRubrica" (change)="isRubrica = $event.checked">Rúbrica</mat-checkbox><br>
    <mat-checkbox color="primary" [checked]="isComentario" (change)="isComentario = $event.checked">Comentarios
    </mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close(null)">Cancelar</button>
  <button mat-raised-button (click)="print()" color="primary" [disabled]="!buttonEnable()">Aceptar</button>
</mat-dialog-actions>
